export enum Console {
  Backup = 'backup',
  GlobalManagement = 'global-management',
  DataPlatform = 'data-platform',
}

const GLOBAL_MANAGEMENT_PREFIX = '/global-management';
const STREAMLAKE_PREFIX = '/streamlake';

export const consoleForPathname = (pathname: string): Console => {
  if (pathname.startsWith(GLOBAL_MANAGEMENT_PREFIX)) {
    return Console.GlobalManagement;
  }
  if (pathname.startsWith(STREAMLAKE_PREFIX)) {
    return Console.DataPlatform;
  }
  return Console.Backup;
};

export const backupLandingPath = (saasInventoryDefaultLanding: boolean) =>
  saasInventoryDefaultLanding ? '/saas-inventory' : '/inventory';

// Backup gets an explicit path rather than '/', which resolves to the account's default console and may not be Backup.
export const consoleLandingPath = (
  target: Console,
  saasInventoryDefaultLanding: boolean
): string => {
  switch (target) {
    case Console.GlobalManagement:
      return '/global-management';
    case Console.DataPlatform:
      return '/streamlake';
    default:
      return backupLandingPath(saasInventoryDefaultLanding);
  }
};
